module.exports = __webpack_public_path__ + "img/salon_setting.d92f780a.svg";